import { Link } from "react-router-dom";
import { siteInfo, siteStats, testimonials } from "@/mocks/site";

export default function BrandSection() {
  return (
    <section className="w-full bg-secondary-50">
      <div className="mx-auto w-full px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.1fr_0.9fr] lg:gap-16">
          <div>
            <span className="text-xs tracking-[0.2em] text-secondary-800">ABOUT&nbsp;US</span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
              一个认真整理梗的地方
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">{siteInfo.intro}</p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              我们不追夸张的标题，也不堆没有意义的图。每一条内容都会标注分类、来源和适合的使用场景，让你在需要的时候能快速找到、放心使用。
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {siteStats.map((stat) => (
                <div key={stat.label} className="rounded-lg border border-secondary-200 bg-background-50 p-4">
                  <p className="font-heading text-2xl text-primary-600">{stat.value}</p>
                  <p className="mt-1 text-xs text-foreground-600">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-1">
            {testimonials.slice(0, 3).map((item) => (
              <figure
                key={item.name}
                className="rounded-lg border border-secondary-200 bg-background-50 p-5"
              >
                <blockquote className="text-sm leading-relaxed text-foreground-800">“{item.text}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className="ri-user-smile-line text-lg"></i>
                  </span>
                  <span>
                    <span className="block text-sm text-foreground-900">{item.name}</span>
                    <span className="block text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-5 rounded-lg bg-primary-500 px-6 py-8 md:flex-row md:items-center md:px-10">
          <div>
            <h3 className="font-heading text-2xl text-background-50">有想看的梗，或者想投稿二创？</h3>
            <p className="mt-2 max-w-xl text-sm text-primary-100">
              把关键词或作品发给我们，合适的会尽快整理上线，并在内容里标注来源。
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/contact"
              className="whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm text-primary-700 transition-colors hover:bg-background-100"
            >
              联系与合作
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap rounded-md border border-primary-100 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}